import React from 'react'
import createReactClass from 'create-react-class'
import ModalWrapper from './modal-wrapper'
import ModalContent from './modal-content'
import './modal-content.scss'

export default createReactClass({
  getInitialState () {
    return {
      updatedTranslation: this.props.translations.trans,
    }
  },
  handleChange (e) {
    const val = e.target.value
    this.setState({updatedTranslation: val})
  },

  onSave (e, resourceId) {
    e.preventDefault()
    const data = {
      updatedText: this.state.updatedTranslation,
      resourceId: resourceId,
      index: this.props.index,
      locale: this.props.translations.locale,
      resourceSet: this.props.translations.resourceSet ? this.props.translations.resourceSet : '',
    }
    this.props.update(data)
  },

  render () {
    const resourceId = this.props.translations.resourceId
    return (
      <ModalWrapper>
        <ModalContent title='Edit Translation' {...this.props}>
          {this.props.error ? <div className='modal-error'>{this.props.error}</div> : ''}
          <form className='refresh-token' onSubmit={(e) => this.onSave(e, resourceId)}>
            <div>
              <p htmlFor='edit-translation'>{'Value (EN)'}</p>
              <input
                placeholder="name"
                name="resource_Id"
                type="text"
                contentEditable={false}
                value={resourceId}
                readOnly
              />
            </div>
            <div>
              <p htmlFor='edit-translation' className='translation-label'>{`Translated Value (${this.props.translations.locale})`}</p>
              <input
                placeholder="Edit translation"
                name="translated_value"
                type="text"
                value={this.state.updatedTranslation}
                onChange={this.handleChange}/>
            </div>
            <div className="pull-right">
              <button type="reset" className="cs-grey-button" onClick={() => this.props.closeModal()}>Cancel</button>
              <button type="submit" className="cs-primary-button" disabled={this.props.loader}>
                {this.props.loader ? <span><i className="fa fa-spinner fa-spin"></i>Saving</span> : 'Save'}</button>
            </div>
          </form>
        </ModalContent>
      </ModalWrapper>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/modal-panels/edit-translations-modal-panel.js